
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface DynamicHeadProps {
  children?: React.ReactNode;
}

/**
 * Component to help search engines understand our SPA routes
 * This adds a special meta tag for crawlers and helps with history API
 */
const DynamicHead: React.FC<DynamicHeadProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Update canonical URL based on the current route
    const canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonicalTag) {
      const url = `https://drcash.com.br${location.pathname}`;
      canonicalTag.setAttribute('href', url);
    } else {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', `https://drcash.com.br${location.pathname}`);
      document.head.appendChild(link);
    }

    // Add special meta tag for SPA crawlers if not present
    if (!document.querySelector('meta[name="fragment"]')) {
      const metaFragment = document.createElement('meta');
      metaFragment.setAttribute('name', 'fragment');
      metaFragment.setAttribute('content', '!');
      document.head.appendChild(metaFragment);
    }

    // Update history state with additional metadata for search engines
    const pathWithoutLeadingSlash = location.pathname.replace(/^\//, '');
    if (pathWithoutLeadingSlash) {
      window.history.replaceState(
        { path: pathWithoutLeadingSlash },
        document.title,
        location.pathname
      );
    }
  }, [location]);

  return <>{children}</>;
};

export default DynamicHead;
